<template>
	<div class="GridFlex-cell" :class="classes">
		<!-- @slot Default slot -->
		<slot />
	</div>
</template>

<script>
export default {
	name: 'CloGridFlexCell',
	data() {
		return {};
	},
	props: {
		alignment: {
			type: String,
			default: '',
		},
		verticalAlignment: {
			type: String,
			default: '',
		},
		order: {
			type: String,
			default: '',
		},
	},
	computed: {
		classes: function () {
			let classes = [];
			const prefix = 'GridFlex-cell--';
			if (this.alignment) {
				classes.push(prefix + this.alignment);
			}

			if (this.verticalAlignment) {
				classes.push(prefix + this.verticalAlignment);
			}

			if (this.order) {
				classes.push(prefix + this.order);
			}
			return classes.join(' ');
		},
	},
};
</script>

<style></style>
